import axios from 'axios';
import user from '../utils/user';

const baseURL = process.env.VUE_APP_API_VIDA_URL;
export default {
  async getProposalHistory(proposalId) {
    try {
      const response = await axios.get(
        `${baseURL}/history/proposal/${proposalId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getPolicyInstallmentsHistory(policyInstallmentId) {
    try {
      const response = await axios.get(
        `${baseURL}/policy/installments/${policyInstallmentId}/log-changes`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
